import React from 'react';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';

const TableStyle = css`
  width: 100%;
  border-collapse: collapse;
  max-height: 500px;
  thead {
    background: ${palette.webGray[2]};
    tr {
      height: 3rem;
      border-top: 2px solid ${palette.webGray[10]};
      border-bottom: 1px solid ${palette.webGray[5]};
    }
  }

  td {
    text-align: center;
  }

  tr {
    height: 3rem;
  }
`;

const StyledTable = styled.table`
  ${TableStyle}
`;

const Table = (props) => {
  return (
    <StyledTable>
      <thead>
        <tr>
          {props.th.map((c, idx) => (
            <th key={idx}>{c}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.data.map((item) =>
          item.photo ? (
            <tr
              key={item[Object.keys(item)[0]]}
              onClick={
                props.onClick
                  ? () => props.onClick(item[Object.keys(item)[0]])
                  : null
              }
            >
              {props.renderingCol.map((c, idx) =>
                c === 'name' ? (
                  <td key={c}>
                    <img
                      src={item.photo}
                      alt="기본 사진"
                      width="24px"
                      height="auto"
                    />
                    {item[c]}
                  </td>
                ) : (
                  <td key={c}>{item[c]}</td>
                ),
              )}
            </tr>
          ) : (
            <tr key={item[Object.keys(item)[0]]}>
              {props.renderingCol.map((c, idx) => (
                <td key={c}>{item[c]}</td>
              ))}
            </tr>
          ),
        )}
      </tbody>
    </StyledTable>
  );
};

export default React.memo(Table);
